import {FooterProps} from '@ui-kit/src/Footer/Footer.types';

import {onSocialClick} from '@dev-landing/components/StrapiFooter/onClickHandlers';

import {FooterStrapi} from '@dev-landing/strapi/types';

export const parseFooterData = ({
  leftSideContent,
  links,
}: FooterStrapi): FooterProps => {
  const socialLinks =
    leftSideContent.devLandingSocialLinks &&
    Object.values(leftSideContent.devLandingSocialLinks).map((item: any) => ({
      href: item.href,
      logoHref: item.logoHref.url,
      target: item.isTargetBlank ? '_blank' : '_self',
      onClick: onSocialClick,
    }));

  const parsedLinks = Object.values(links).map((item) => ({
    title: item.title,
    elements: Object.values(item.elements).map((item) => ({
      title: item.title,
      href: item.href,
      target: item.isTargetBlank ? '_blank' : '_self',
    })),
  }));

  return {
    links: parsedLinks,
    leftSideContent: {
      copyright: {__html: leftSideContent.copyright},
      qrCodeHref: leftSideContent.qrCodeHref.url,
      rustoreLogoHref: leftSideContent.rustoreLogoHref.url,
      qrCodeDescription: {__html: leftSideContent.qrCodeDescription},
      socialLinks,
    },
  };
};
